var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDerricks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.55662V3C7 2.44771 7.44772 2 8 2H10C10.3154 2 10.5968 2.14605 10.78 2.37422L7 4.55662Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3.97925L7 6.28865V6.47484L3.47486 9.99998H3C2.44772 9.99998 2 10.4477 2 11V12C2 12.5523 2.44772 13 3 13H9.23205L7 14.2887V17.5566L10.8212 15.3505C10.8787 15.3173 10.9388 15.2925 11 15.2759V13H17.0854C17.2051 13.3389 17.4432 13.6219 17.75 13.7993V16.5H17C16.4477 16.5 16 16.9477 16 17.5V18.5C16 19.0523 16.4477 19.5 17 19.5H20C20.5523 19.5 21 19.0523 21 18.5V17.5C21 16.9477 20.5523 16.5 20 16.5H19.25V13.7993C19.5568 13.6219 19.7949 13.3389 19.9146 13H21C21.5523 13 22 12.5523 22 12V11C22 10.4477 21.5523 9.99998 21 9.99998H19.9146C19.7087 9.41738 19.1531 8.99998 18.5 8.99998C17.8469 8.99998 17.2913 9.41738 17.0854 9.99998H14.9525C14.9166 9.89486 14.8568 9.79612 14.773 9.71229L11 5.93932V3.97925ZM5.59618 9.99998L7.0936 8.50257L9.85033 6.91097L10.9484 8.00904L7.5 9.99998H5.59618ZM11 9.99998V8.06064L12.9393 9.99998H11Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 21V19.2887L11 16.9793V21H12C12.5523 21 13 21.4477 13 22C13 22.5523 12.5523 23 12 23H6C5.44772 23 5 22.5523 5 22C5 21.4477 5.44772 21 6 21H7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDerricks);
export default __webpack_public_path__ + "static/media/derricks.64ff4734b75e9642e7d952adb195182c.svg";
export { ForwardRef as ReactComponent };